import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import * as RouterActions from '../../../actions/RouterActions';
import { Table, Form, Icon, Label, Menu } from 'semantic-ui-react'
import {Mapping} from './mapping';
import _ from 'lodash';

export function OutcomeRow(props){

    let mappings = (typeof props.market.mappings === 'undefined' || props.market.mappings === null || typeof props.market.mappings[props.outcome.canvas.code] === 'undefined')?{}:props.market.mappings[props.outcome.canvas.code];
    let [activeItem, setActiveItem] = useState(null);
    let [alternativeNamesEditMode, setAlternativeNamesEditMode] = useState(false);
    let [alternativeKeyValue, setAlternativeKeyValue] = useState('');

    /*mappings.name = [
        {type: 'static', 'value': 'Unentschieden'},
        {type: 'path', 'path': '$.homeTeam.name', translate: true}
    ];*/

    useEffect(() => {
        if(activeItem !== null && activeItem === '+'){
            setAlternativeNamesEditMode(true);
            setAlternativeKeyValue('');
        }else if(activeItem !== null){
            setAlternativeKeyValue(activeItem);
            setAlternativeNamesEditMode(false);
        }
    }, [activeItem]);

    useEffect(() => {
        setActiveItem(null);
    }, [props.market.mappings])

    const handleAlternativeNameUpdate = (mapping) => {
        const newMappings = _.clone(mappings);

        if(mapping === null){
            if(activeItem !== '+'){
                delete newMappings['alternative-names'][activeItem];
                props.onMappingsChanged(newMappings);
            }
        }else{
            if(typeof newMappings['alternative-names'] === 'undefined')
                newMappings['alternative-names'] = {};

            if(alternativeKeyValue.length > 0){
                
                let key = alternativeKeyValue.replace(/\s+/g, '');
                newMappings['alternative-names'][key] = mapping;

                if(key !== activeItem && activeItem !== '+')
                    delete newMappings['alternative-names'][activeItem];
            }

            props.onMappingsChanged(newMappings);
        }
    };

    const handleNameUpdate = (mapping) => {
        const newMappings = _.cloneDeep(mappings);

        if(mapping === null){
            if(typeof newMappings.name !== 'undefined'){
                delete newMappings.name;
                props.onMappingsChanged(newMappings);
            }
        }else{
            newMappings.name = _.cloneDeep(mapping);

            props.onMappingsChanged(newMappings);
        }
    };

    return (
        <Table.Row>
            {
                (typeof props.showUid === 'undefined' || props.showUid)?
                    <Table.Cell>{props.outcome.uid}</Table.Cell>
                :null
            }
            <Table.Cell>{props.outcome.canvas.code}</Table.Cell>
            <Table.Cell>{props.outcome.canvas.type}</Table.Cell>
            <Table.Cell><a style={{cursor: 'pointer'}} onClick={props.onClick}>{
                (typeof props.outcome.canvas.clean !== 'undefined')
                    ?props.outcome.canvas.clean
                    :'Unknown'
                }</a>
            </Table.Cell>
            <Table.Cell>{
                <Mapping onChange={(mapping) => handleNameUpdate(mapping)} mapping={(typeof mappings.name === 'undefined')?null:mappings.name} />
            }</Table.Cell>
            <Table.Cell>
                <Menu size="tiny" secondary>
                    {
                        (typeof mappings['alternative-names'] !== 'undefined')?
                            Object.keys(mappings['alternative-names']).map((alternativeKey) => 
                                <Menu.Item content={alternativeKey} key={alternativeKey} name={alternativeKey} active={activeItem === alternativeKey} onClick={(e) => setActiveItem(alternativeKey)} />
                            )
                        :null
                    }  
                    <Menu.Item position="right" active={activeItem === '+'} onClick={(e) => setActiveItem('+')}>
                        <Icon name="plus" />
                    </Menu.Item>
                </Menu>
                {
                    (activeItem !== null)?
                        <Fragment>
                            {
                                (alternativeNamesEditMode)?
                                    <Form>
                                        <Form.Input value={alternativeKeyValue} label="Name:" onChange={(e) => setAlternativeKeyValue(e.target.value)} />
                                    </Form>
                                :null
                            }
                            {
                                (alternativeNamesEditMode)?
                                    <div style={{
                                        fontWeight: 'bold',
                                        marginTop: '0.3em',
                                        marginBottom: '0.3em'
                                    }}>Inhalt:</div>
                                :null
                            }
                            <Mapping onChange={(mapping) => handleAlternativeNameUpdate(mapping)} editMode={alternativeNamesEditMode} onSetEditMode={(editMode) => setAlternativeNamesEditMode(editMode)} alternativeKey={activeItem} mapping={(typeof mappings['alternative-names'] !== 'undefined' && typeof mappings['alternative-names'][activeItem] !== 'undefined')?mappings['alternative-names'][activeItem]:null} />
                        </Fragment>
                    :null
                }
            </Table.Cell>
            <Table.Cell>{props.outcome.canvas.handicap}</Table.Cell>
            <Table.Cell>standard</Table.Cell>
        </Table.Row>
    )
}